import { DeliveryMethod } from '@1po/1po-bff-fe-spec/generated/my_network/request/UpdateMyNetworkClientRequest';
import { ClientSettingsFormType } from './GarageDetails.types';

export const FORM_FIELDS: Record<string, keyof ClientSettingsFormType> = {
  ACTIVE: 'active',
  DELIVERY_METHOD: 'deliveryMethod',
  AUTOMATIC_ORDER_TRANSFER: 'automaticOrderTransfer',
  MANAGE_CREDIT_LIMIT: 'manageCreditLimit',
  MAX_ORDER_AMOUNT: 'maxOrderAmount',
  MAX_INVOICE_AMOUNT: 'maxInvoiceAmount',
} as const;

export const DELIVERY_METHODS: Record<string, DeliveryMethod> = {
  DIRECT: 'DIRECT',
  DESK: 'DESK',
} as const;
